module.exports = __webpack_public_path__ + "img/suit-01.dae3f883.png";